module.exports = __webpack_public_path__ + "assets/autotest4.jpg?2cdc4983c36d59468b639cdcc72f368d";